import { render, staticRenderFns } from "./OptimizerArea.vue?vue&type=template&id=7ede669c&scoped=true&"
import script from "./OptimizerArea.vue?vue&type=script&lang=js&"
export * from "./OptimizerArea.vue?vue&type=script&lang=js&"
import style0 from "./OptimizerArea.vue?vue&type=style&index=0&id=7ede669c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ede669c",
  null
  
)

export default component.exports